var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"justify-center"},[_c('v-chip',{domProps:{"innerHTML":_vm._s(_vm.formatTime(_vm.lapsedMilliseconds))}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }